module.exports = __webpack_public_path__ + "components/flag/static/square/mz-14401617948f9e531aa2f2ca889ec0b2.svg";